// import React, { useState, useEffect } from "react";
// import { Link, useNavigate, useLocation } from "react-router-dom";
// import { useTranslation } from "react-i18next";
// import { Menu, X, Globe, LogOut, ChevronDown } from "lucide-react";
// import logo from "@/assets/logo.png"

// import { Button } from "@/components/ui/button";
// import {
//   DropdownMenu,
//   DropdownMenuContent,
//   DropdownMenuItem,
//   DropdownMenuTrigger,
// } from "@/components/ui/dropdown-menu";

// const Header = () => {
//   const { t, i18n } = useTranslation();
//   const navigate = useNavigate();
//   const location = useLocation();

//   const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
//   const [menuData, setMenuData] = useState([]);
//   const [menuLoaded, setMenuLoaded] = useState(false);
//   const [openMenu, setOpenMenu] = useState(null);

//   const isAdmin = location.pathname.startsWith("/admin");
//   const isLoggedIn = localStorage.getItem("admin_token");

//   useEffect(() => {
//     const BASE_URL =
//       import.meta.env.VITE_BACKEND_URL || "http://localhost:8000";

//     fetch(`${BASE_URL}/api/public/services-menu`)
//       .then((res) => res.json())
//       .then((data) => {
//         setMenuData(Array.isArray(data) ? data : []);
//         setMenuLoaded(true);
//       })
//       .catch((err) => {
//         console.error("Menu API failed", err);
//         setMenuLoaded(true);
//       });
//   }, []);

//   const changeLanguage = (lng) => i18n.changeLanguage(lng);

//   const handleLogout = () => {
//     localStorage.removeItem("admin_token");
//     localStorage.removeItem("admin_user");
//     navigate("/admin/login");
//   };

//   return (
//     <header className="sticky top-0 z-50 bg-white border-b">
//       <div className="max-w-7xl mx-auto px-4">
//         <div className="flex justify-between items-center h-16">

//           {/* Logo */}
//           <Link to="/" className="flex items-center gap-2">
//             <div className="w-[177px] h-[100px] flex items-center justify-center">
//               <img src={logo} alt="Logo" className="object-contain" />
//             </div>
//           </Link>

//           {/* Desktop Navigation */}
//           {!isAdmin && menuLoaded && (
//             <nav className="hidden lg:flex items-center gap-2">

//               <Link
//                 to="/"
//                 className="px-4 py-2 font-medium hover:text-accent"
//               >
//                 Home
//               </Link>

//               {menuData.map((group) => (
//                 <div
//                 key={group.id}
//                 className="relative"
//                 onMouseEnter={() => setOpenMenu(group.id)}
//                 onMouseLeave={() => setOpenMenu(null)}
//               >
//                 <button
//                   className={`
//                     px-4 py-2 font-medium flex items-center gap-1
//                     transition-colors
//                     ${openMenu === group.id ? "text-accent" : "hover:text-accent"}
//                   `}
//                 >
//                   {group.name}
//                   <ChevronDown
//                     className={`h-4 w-4 transition-transform ${
//                       openMenu === group.id ? "rotate-180" : ""
//                     }`}
//                   />
//                 </button>
              
//                 {/* Hover buffer to prevent flicker */}
//                 <div className="absolute inset-x-0 top-full h-3" />
              
//                 <div
//                   className={`
//                     absolute left-0 top-full mt-1 w-72 z-50
//                     rounded-xl bg-white border shadow-xl
//                     transition-all duration-200 ease-out
//                     ${
//                       openMenu === group.id
//                         ? "opacity-100 translate-y-0 pointer-events-auto"
//                         : "opacity-0 translate-y-2 pointer-events-none"
//                     }
//                   `}
//                 >
//                   <ul className="py-2">
//                     {group.services?.map((service) => (
//                       <li key={service.id}>
//                         <Link
//                           to={`/services/${service.id}`}
//                           className="
//                             block px-4 py-2 text-sm
//                             hover:bg-accent/10
//                             transition-colors
//                           "
//                         >
//                           {service.name}
//                         </Link>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//               ))}

//               <Link
//                 to="/appointments/new"
//                 className="px-4 py-2 font-medium hover:text-accent"
//               >
//                 Book an Appointment
//               </Link>
//               <Link
//                 to="/grievances"
//                 className="px-4 py-2 font-medium hover:text-accent"
//               >
//                 Submit Grievance
//               </Link>
//             </nav>
//           )}

//           {/* Right Side */}
//           <div className="hidden md:flex items-center gap-3">
//             <DropdownMenu>
//               <DropdownMenuTrigger asChild>
//                 <Button variant="ghost" size="icon">
//                   <Globe className="h-5 w-5" />
//                 </Button>
//               </DropdownMenuTrigger>
//               <DropdownMenuContent align="end">
//                 <DropdownMenuItem onClick={() => changeLanguage("en")}>
//                   English
//                 </DropdownMenuItem>
//                 <DropdownMenuItem onClick={() => changeLanguage("ko")}>
//                   한국어
//                 </DropdownMenuItem>
//                 <DropdownMenuItem onClick={() => changeLanguage("th")}>
//                   ไทย
//                 </DropdownMenuItem>
//               </DropdownMenuContent>
//             </DropdownMenu>

//             {isAdmin && isLoggedIn && (
//               <Button variant="ghost" size="sm" onClick={handleLogout}>
//                 <LogOut className="h-4 w-4 mr-2" />
//                 {t("logout")}
//               </Button>
//             )}
//           </div>

//           {/* Mobile Toggle */}
//           <button
//             className="lg:hidden"
//             onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
//           >
//             {mobileMenuOpen ? <X /> : <Menu />}
//           </button>
//         </div>
//       </div>
//     </header>
//   );
// };

// export default Header;


import React, { useState, useEffect } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Menu, X, Globe, LogOut, ChevronDown } from "lucide-react";
import logo from "@/assets/logo.png"

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

const Header = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const location = useLocation();

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [menuData, setMenuData] = useState([]);
  const [menuLoaded, setMenuLoaded] = useState(false);
  const [openMenu, setOpenMenu] = useState(null);

  const isAdmin = location.pathname.startsWith("/admin");
  const isLoggedIn = localStorage.getItem("admin_token");

useEffect(() => {
   const BASE_URL =
      process.env.REACT_APP_BACKEND_URL;

  fetch(`${BASE_URL}/api/public/services-menu`)
  .then((res) => res.json())
  .then((data) => {
    console.log(data); // Log the data to check the response
    setMenuData(Array.isArray(data) ? data : []);
    setMenuLoaded(true);
  })
  .catch((err) => {
    console.error("Menu API failed", err);
    setMenuLoaded(true);
  });

  }, []);

 

  console.log("Menu",menuData)

  const changeLanguage = (lng) => i18n.changeLanguage(lng);

  const handleLogout = () => {
    localStorage.removeItem("admin_token");
    localStorage.removeItem("admin_user");
    navigate("/admin/login");
  };

  return (
    <header className="sticky top-0 z-50 bg-white border-b border-gray-200 shadow-sm">
      <div className="max-w-7xl mx-auto px-5">
        <div className="flex justify-between items-center h-20">

          {/* Logo */}
          <Link to="/" className="flex items-center flex-shrink-0">
            <div className="h-14 w-auto flex items-center">
              <img src={logo} alt="Logo" className="h-full w-auto object-contain" />
            </div>
          </Link>

          {/* Desktop Navigation */}
          {!isAdmin && menuLoaded && (
            <nav className="hidden lg:flex items-center gap-1 flex-1 justify-center">

              <Link
                to="/"
                className="px-4 py-2 text-[15px] font-medium text-gray-700 hover:text-[#511313] transition-colors whitespace-nowrap"
              >
                Home
              </Link>

              {menuData.map((group) => (
                <div
                  key={group.id}
                  className="relative"
                  onMouseEnter={() => setOpenMenu(group.id)}
                  onMouseLeave={() => setOpenMenu(null)}
                >
                  <button
                    className={`
                      px-4 py-2 text-[15px] font-medium flex items-center gap-1
                      transition-colors whitespace-nowrap
                      ${openMenu === group.id ? "text-[#511313]" : "text-gray-700 hover:text-[#511313]"}
                    `}
                  >
                    {group.name}
                    <ChevronDown
                      className={`h-4 w-4 transition-transform ${
                        openMenu === group.id ? "rotate-180" : ""
                      }`}
                    />
                  </button>
                
                  {/* Hover buffer to prevent flicker */}
                  <div className="absolute inset-x-0 top-full h-3" />
                
                  <div
                    className={`
                      absolute left-0 top-full mt-1 w-64 z-50
                      rounded-lg bg-white border border-gray-200 shadow-xl
                      transition-all duration-200 ease-out
                      ${
                        openMenu === group.id
                          ? "opacity-100 translate-y-0 pointer-events-auto"
                          : "opacity-0 translate-y-2 pointer-events-none"
                      }
                    `}
                  >
                    <ul className="py-2">
                      {group.services?.map((service) => (
                        <li key={service.id}>
                          <Link
                            to={`/services/${service.id}`}
                            className="
                              block px-4 py-2.5 text-[14px] text-gray-700
                              hover:bg-[#511313]/5 hover:text-[#511313]
                              transition-colors
                            "
                          >
                            {service.name}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}

              <Link
                to="/appointment-management"
                className="px-4 py-2 text-[15px] font-medium text-gray-700 hover:text-[#511313] transition-colors whitespace-nowrap"
              >
                Appointment Management
              </Link>
               <Link
                to="/track-application"
                className="px-4 py-2 text-[15px] font-medium text-gray-700 hover:text-[#511313] transition-colors whitespace-nowrap"
              >
                Track Application
              </Link>
               <Link
                to="/optional-services"
                className="px-4 py-2 text-[15px] font-medium text-gray-700 hover:text-[#511313] transition-colors whitespace-nowrap"
              >
                Optional Services
              </Link>
              <Link
                to="/grievances"
                className="px-4 py-2 text-[15px] font-medium text-gray-700 hover:text-[#511313] transition-colors whitespace-nowrap"
              >
                Submit Grievance
              </Link>
            </nav>
          )}

         

          {/* Mobile Toggle */}
          <button
            className="lg:hidden p-2 text-gray-700 hover:text-[#511313] hover:bg-gray-100 rounded-lg transition-colors"
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
          >
            {mobileMenuOpen ? <X className="h-6 w-6" /> : <Menu className="h-6 w-6" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && (
        <div className="lg:hidden border-t border-gray-200 bg-white">
          <nav className="px-6 py-4 space-y-1">
            <Link
              to="/"
              className="block px-4 py-2.5 text-[15px] font-medium text-gray-700 hover:text-[#511313] hover:bg-[#511313]/5 rounded-lg transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Home
            </Link>

            {menuData.map((group) => (
              <div key={group.id} className="space-y-1">
                <div className="px-4 py-2 text-[15px] font-semibold text-gray-900">
                  {group.name}
                </div>
                {group.services?.map((service) => (
                  <Link
                    key={service.id}
                    to={`/services/${service.id}`}
                    className="block px-8 py-2 text-[14px] text-gray-600 hover:text-[#511313] hover:bg-[#511313]/5 rounded-lg transition-colors"
                    onClick={() => setMobileMenuOpen(false)}
                  >
                    {service.name}
                  </Link>
                ))}
              </div>
            ))}

            <Link
              to="/appointments/new"
              className="block px-4 py-2.5 text-[15px] font-medium text-gray-700 hover:text-[#511313] hover:bg-[#511313]/5 rounded-lg transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Book an Appointment
            </Link>
            <Link
              to="/grievances"
              className="block px-4 py-2.5 text-[15px] font-medium text-gray-700 hover:text-[#511313] hover:bg-[#511313]/5 rounded-lg transition-colors"
              onClick={() => setMobileMenuOpen(false)}
            >
              Submit Grievance
            </Link>

          
          </nav>
        </div>
      )}
    </header>
  );
};

export default Header;